// extracted by mini-css-extract-plugin
module.exports = {"Row":"SignInUpForm_Row__3PbVy","Input":"SignInUpForm_Input__3xaLZ","Header":"SignInUpForm_Header__3joQJ","Link":"SignInUpForm_Link__1BeMm"};